import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, getToken } from '../asyncConfig';

export const getAllRides = createAsyncThunk(
  'rides/getAllRides', async (criteria, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.get(
        `${BASE_URL}/admin/rides/${criteria}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.rides);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const endRideById = createAsyncThunk(
  'rides/endRide', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}/admin/rides/end/${id}`,
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getRideFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.rides = action.payload;
}


export const getRideHistoryById = createAsyncThunk(
  'users/ride-history', async (id, {fulfillWithValue, rejectWithValue}) => {
    try {
      const {data} = await axios.get(
        `${BASE_URL}/admin/user/ride-history/${id}`, 
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getUserHistory = (state, action) => {
  console.log('action:', action);
  state.status = '';
  state.user = action.payload.user;
  state.rides = action.payload.trips;  
}

export const getRideDetailsById = createAsyncThunk(
  'rides/getRideById', async (id, {fulfillWithValue, rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/admin/rides/details/${id}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(res.data.ride);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)
